__turbopack_context__.v({
  "name": "tooltipStyles-module-scss-module__Mde1HG__name",
  "tooltipBox": "tooltipStyles-module-scss-module__Mde1HG__tooltipBox",
  "value": "tooltipStyles-module-scss-module__Mde1HG__value",
});
